import React, { useState, useRef } from 'react'

import { videoEvents } from 'lib/ga'
import { withLogger } from 'lib/logger'
import VideoChapters from 'components/VideoChapters'
import VideoPlayer from 'components/VideoPlayer'

const logger = withLogger('StoryVideoPlayer')
const percentsPlayedInterval = 10

export const StoryVideoPlayer = ({ story, storyVideoSource, playNextVideo, ...props }) => {
  const player = useRef()
  const [currentTime, setCurrentTime] = useState(0)
  const [duration, setDuration] = useState(0)

  async function handleChapterClick(chapter) {
    try {
      await player.current.play()
    } catch (e) {
      logger.error('Chapter Click Error: ', e)
    } finally {
      player.current.currentTime = chapter.time
    }
  }

  function handleOnTimeUpdate() {
    const label = `${storyVideoSource.id} | ${storyVideoSource.name}`
    let percentsAlreadyTracked = []
    let seekEnd
    let seekStart = (seekEnd = 0)
    const currentTime = Math.round(player.current?.currentTime)
    const duration = Math.round(player.current?.duration)
    setCurrentTime(currentTime)
    setDuration(duration)

    const percentPlayed = Math.round((currentTime / duration) * 100)

    for (let percent = 0, step = percentsPlayedInterval; percent <= 99; percent += step) {
      if (percentPlayed >= percent && !percentsAlreadyTracked.includes(percent) && percentPlayed !== 0) {
        videoEvents.percentPlayed({ label, value: percent })
        percentsAlreadyTracked.push(percent)
      }
    }
    seekStart = seekEnd
    seekEnd = currentTime
    // if the difference between the start and the end are greater than 1 it's a seek.
    if (Math.abs(seekStart - seekEnd) > 1) {
      videoEvents.seekStart({ label, value: seekStart })
      videoEvents.seekEnd({ label, value: seekEnd })
    }
  }

  return (
    <div className='videoPlayer'>
      <VideoPlayer
        {...props}
        ref={player}
        src={storyVideoSource?.sources?.[0].src}
        onEnded={() => playNextVideo?.()}
        onTimeUpdate={handleOnTimeUpdate}
        muxData={{
          video_id: String(story.id),
          video_variant_id: String(story.post_type_meta.barstool_original.id),
          video_title: story.title,
          video_series: story.brand_name || story.author.name
        }}
      />
      {storyVideoSource.cue_points && (
        <VideoChapters
          cuePoints={storyVideoSource.cue_points}
          onClick={handleChapterClick}
          currentTime={currentTime}
          duration={duration}
        />
      )}
    </div>
  )
}

export default StoryVideoPlayer
